import { AddShoppingCart, TrendingUpOutlined } from '@mui/icons-material'
import { Tooltip, Zoom } from '@mui/material'
import React, { useContext, useEffect, useReducer } from 'react'
import FavSection from './FavSection'
import TruncateText from '../../../components/TruncateText'
import AuthroizedImages from './AuthroizedImages'
import { AppContext } from '../../../Layout/Layout'
import { useTranslation } from 'react-i18next'
import { Skeleton } from 'primereact/skeleton'
import InventoryByProduct from './InventoryByProduct'
import { Button } from 'primereact/button'
import ProductUnavailable from './ProductCommonUIs/ProductUnavailable'
import PriceSection from './PriceSection'
import CustomTooltip from '../../../components/CustomTooltip'


const ProductCardInitial = {
    PriceDetails: { Status: "Loading", ButtonStatus: "Loading" },
    QtyDetails: { Status: "Loading", ActStock: 9999, CurrentStock: 9999, UOM: "" }
}
const ProductCardReducer = (state, action) => {
    switch (action.type) {
        case "PriceDetails":
            return { ...state, PriceDetails: action.payload }
        case "QtyDetails":
            return { ...state, QtyDetails: { ...state.QtyDetails, ...action.payload } }
        case "ReduceQty":
            return { ...state, QtyDetails: { ...state.QtyDetails, CurrentStock: state.QtyDetails.CurrentStock - action.payload } }
        default:
            return state
    }

}



const ProductCard = ({ Product, handleProductClick, CardStyle, CatagoryHeader }) => {
    const { t } = useTranslation();
    const {
        CartProductRelatedStates: { CartProductsList: { CartProductsIDs }, CartDetails },
        taxDetails: { InventoryStatus } } = useContext(AppContext);

    const isProductInCart = CartProductsIDs.includes(Product.id);
    const [ProductCardState, setProductCardState] = useReducer(ProductCardReducer, ProductCardInitial);
    const productView = () => {
        handleProductClick({ Product, ProductCardState, setProductCardState })
    }
    //When Inventory not available show Add to Cart button (Unlimited stock)
    useEffect(() => {
        if (!InventoryStatus) {
            setProductCardState({ type: "QtyDetails", payload: { Status: "InStock", ActStock: 9999, CurrentStock: 9999, UOM: "" } })
        }
    }, [InventoryStatus])



    return (
        <>
            <div className={`card flex flex-column  justify-content-between   ${isProductInCart && "bg-gray-100"}`} style={CardStyle}>
                {(isProductInCart && CartDetails.Status === "Open") && <div className='ribbonCard'>Added</div>}
                {(isProductInCart && CartDetails.Status === "InProgress") && <div className="ribbonCardOrderProcessing">{t('Order Processing')}</div>}
                {(isProductInCart && CartDetails.Status === "Ordered") && <div className="ribbonCardOrdered">{t('Recently Ordered')}</div>}

                {/* Catalog,Trending,Fav  */}
                {CatagoryHeader && <div className='pl-1 flex justify-content-between align-items-center '>
                    <div >
                        <span className="text-xs font-semibold flex gap-1">
                            <i className="pi pi-tag mt-1" style={{ fontSize: "0.7rem" }} />
                            <TruncateText text={Product.ProductCategoryName} maxLength={22} /></span>
                    </div>

                    <div className='flex gap-2  justify-content-center align-items-center'>
                        <div>
                            {Product.ProductStatus === "Trending" && (
                                <CustomTooltip text={"Trending product"} placement="bottom">
                                    <TrendingUpOutlined className="glowing text-sm"></TrendingUpOutlined>
                                </CustomTooltip>
                                
                            )}
                        </div>
                        <div>
                            <FavSection ProductID={Product.id} />
                        </div>
                    </div>
                </div>}

                {/* Image Section         */}
                <div className='pl-1 pr-1 cursor-pointer' >
                    <AuthroizedImages ProductImage={Product.ProductImage} imageStyle={{ borderRadius: "8px", height: "130px" }} onClick={productView} />
                </div>

                {/* Description Section              */}
                <div className='p-1 text-left'>
                    <CustomTooltip text={Product.ProductName} placement="bottom">
                        <div className=" pl-1 pr-1  text-ellipsis text-sm font-semibold cursor-pointer hover:text-blue-600" onClick={productView}>
                            <TruncateText text={Product.ProductName} maxLength={40} />
                        </div>
                    </CustomTooltip>
                    
                </div>

                {/* Price Section  */}
                <div className={`p-1 pl-2 text-left`}>
                    <>
                        <PriceSection ProductID={Product.id} ProductCardState={ProductCardState} setProductCardState={setProductCardState} priceClass="text-2xl" />
                    </>
                </div>

                {/* Inventory section  */}
                {InventoryStatus && <div className='p-1'>
                    <InventoryByProduct ProductID={Product.id} ProductCardState={ProductCardState} setProductCardState={setProductCardState} />
                </div>}


                {/* Button Section  */}
                {(ProductCardState.PriceDetails.ButtonStatus === "Loading" || ProductCardState.QtyDetails.Status === "Loading") &&
                    <div className=''>
                        <Skeleton height="2rem" className='border-noround border-round-bottom'></Skeleton>
                    </div>
                }
                {(ProductCardState.PriceDetails.ButtonStatus === "AddtoCart" && ProductCardState.QtyDetails.Status === "InStock" && ProductCardState.QtyDetails.CurrentStock > 0) &&
                    <Button label={`${(isProductInCart && CartDetails.Status === "Open") ? "Add More" : "Add to Cart"} `}
                        icon={<AddShoppingCart fontSize='small'></AddShoppingCart>}
                        onClick={productView} iconPos="left" raised
                        className={` ${(isProductInCart && CartDetails.Status === "Open") ? "primary-button" : "primary-button-outlined"} font-semibold w-100 border-noround border-round-bottom border-none  text-sm  `}
                    > </Button>
                }

                {ProductCardState.PriceDetails.ButtonStatus === "Unavailable" &&
                    <div>
                        <ProductUnavailable />
                    </div>
                }

            </div>

        </>
    )
}

export default ProductCard